export const isToday = (dateString: string): boolean => {
  if (!dateString) {
    return false;
  }

  const inputDate = new Date(dateString);
  const today = new Date();

  return (
    inputDate.getFullYear() === today.getFullYear()
    && inputDate.getMonth() === today.getMonth()
    && inputDate.getDate() === today.getDate()
  );
};

export function isValidDate(value: unknown): boolean {
  if (value == null || value === "") {
    return false;
  }

  if (typeof value === "string" || typeof value === "number" || value instanceof Date) {
    const d = new Date(value);
    return !Number.isNaN(d.getTime()) && String(value).trim() !== "";
  }

  return false;
}
